module.exports = __webpack_public_path__ + "static/16-chinawall-1997-0204b60dbc812a33fabbc0a6be02861a.jpg";